<template>
  <div>
    <common-dialog 
      ref="dialog" 
      width="800px" 
      unit="驾校合作模式" 
      edit-title 
      id-key="CoopId" 
      :data="data"
      form-label-width="85px" 
      :form-rules="rules" 
      :save-func="isSubmit?api.submit:api.save" 
      :get-data-func="api.info" 
      close-on-saved
      @create-opened="onCreateOpened" 
      @edit-opened="onEditOpened" 
      @closed="onClosed" 
      :before-save="onBeforeSave"
      @details-opened="onDetailsOpened" 
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="归属机构" prop="DpId">
              <tree-select ref="treeSelect" :props="props" :options="TreeData" :value="data.DpId"
               :clearable="false" :accordion="true" :parentSelect="true" placeholder="请选择"
                @node-select="onTreeSelect($event)" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合作模式" prop="CoopMode">
              <el-select v-model="data.CoopMode" @change="ChangeMode()">
                <el-option value="学员名额出库一次性收费" />
                <el-option value="学员名额出库收费+学时收费分成" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="签约时间" prop="SignDate">
              <el-date-picker v-model.trim="data.SignDate" type="date" value-format="yyyy-MM-dd" placeholder="选择时间"
                style="width:100%;">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="Status">
              <el-radio-group v-model="data.Status">
                <el-radio :label="1">正常</el-radio>
                <el-radio :label="0">终止</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" v-if="data.Status==0">
            <el-form-item label="终止时间" prop="StopDate">
              <el-date-picker v-model.trim="data.StopDate" type="date" value-format="yyyy-MM-dd" placeholder="选择时间"
                style="width:100%;">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <div>名额单价</div>
            <el-table ref="coopTable1" :data="opCoopDtsDtos" border size="small" style="width:100%;margin:10px 0;">
              <el-table-column prop="CarType" label="培训车型" align="center" min-width="80" />
              <el-table-column prop="Price" label="出库单价" width="120" align="center">
                <template slot-scope="{row}">
                  <el-input v-model="row.Price" @blur="changeNum(row)" type="number" class="append"><template slot="append">元</template></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-col>

          <el-col :span="16" style="padding-left: 8px;">
            <div>计时单价</div>
            <el-table ref="coopTable2" :data="opCoopDtsDtos" border size="small" style="width:100%;margin:10px 0;">
              <el-table-column prop="CarType" label="培训车型" align="center" min-width="80">
                <template slot-scope="{row}">
                  <div style="padding:2.5px 0;">{{row.CarType}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="PracticeName" label="课程" width="80" align="center" />
              <el-table-column prop="PracticePrice" label="计时单价" width="120" align="center">
                <template slot-scope="{row}">
                  <el-input v-model="row.PracticePrice" @blur="changeNum(row)" type="number"
                    v-if="data.CoopMode!='学员名额出库一次性收费'" class="append"><template slot="append">元</template></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="SimulateName" label="课程" width="80" align="center" />
              <el-table-column prop="SimulatePrice" label="计时单价" width="120" align="center">
                <template slot-scope="{row}">
                  <el-input v-model="row.SimulatePrice" @blur="changeNum(row)" type="number"
                    v-if="data.CoopMode!='学员名额出库一次性收费'" class="append"><template slot="append">元</template></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </template>
      <template slot="footer" >
        <el-button type="warning" @click="toSave(0)">保 存</el-button>
        <el-button type="primary" v-if="data.ReviewStatus==0||data.ReviewStatus==2" @click="toSave(1)">提 交</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
  import editDialogMixin from "@/mixins/editDialog";
  import commonDialog from "@/components/common/dialog";
  import api from "@/api/op/coop";
  import treeSelect from "@/components/common/treeSelect";

  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
      treeSelect,
    },
    data() {
      return {
        data: {
          CoopId: 0,
          CoopMode: "学员名额出库一次性收费",
          SignDate: "",
          StopDate: "",
          DpId: null,
          Status: 1,
          ReviewStatus: 0,
          opCoopDtsDtos: [],
        },
        api,
        dpApi: require("@/api/basic/dp").default,
        basicApi: require("@/api/basic/data").default,
        rules: {
          SignDate: [{ required: true, message: "请选择签约时间" }],
          CoopMode: [{ required: true, message: "请选择合作模式" }],
          DpId: [{ required: true, message: "请选择所属组织" }],
          StopDate: [{ required: true, message: "请选择终止时间" }],
        },
        TreeData: [],
        dpList: [],
        opCoopDtsDtos: [],
        isSubmit: false,
        props: {
          value: "DpId",
          label: "DpName",
          children: "children",
        },
      };
    },
    computed: {},
    methods: {
      onCreateOpened() {
        this.GetBaseData();
        this.getTreeData();
        this.data.DpId = null;
      },
      onEditOpened(data) {
        this.opCoopDtsDtos = data.opCoopDtsDtos;
        if (this.opCoopDtsDtos.length > 0) {
          this.opCoopDtsDtos.forEach((e) => {
            e.PracticeName = "实操";
            e.SimulateName = "模拟";
            e.T = null;
          });
        }
        this.getTreeData();
      },
      onDetailsOpened(row) {
        this.onEditOpened(row)
      },
      getTreeData() {
        this.dpApi.getAuthList({ DpTypes: [2,3,4], Status: 3, NoReturnParent: true }).then((res) => {
          this.TreeData = this.$commonJs.toTreeData(res.Data, "DpId");
          if (this.data.DpId) {
            this.$refs.treeSelect.setData(this.data.DpId);
          }
        });
      },
      GetBaseData() {
        this.basicApi.list({ ClassName: "培训车型", Status: 1 }).then(res => {
          res.Data.forEach(e => {
            var item = {
              CoopDtsId: 0,
              CoopId: 0,
              CarType: e.DataName,
              Price: null,
              PracticePrice: null,
              SimulatePrice: null,
              PracticeName: "实操",
              SimulateName: "模拟",
              T: 0
            }
            this.opCoopDtsDtos.push(item);
          });
        });
      },
      ChangeMode() {
        this.opCoopDtsDtos.forEach((e) => {
          e.PracticePrice = this.data.CoopMode == '学员名额出库一次性收费'?0:null;
          e.SimulatePrice = this.data.CoopMode == '学员名额出库一次性收费'?0:null;
          if(!(e.T === 0)) {
            e.T = 1;
          }
        });
      },
      changeNum(row) {
        if (!(row.T === 0)) {
          row.T = 1
        }
      },
      onTreeSelect(t) {
        if (!t) {
          this.data.DpId = 0;
        } else {
          this.data.DpId = t.DpId;
        }
      },
      onBeforeSave() {
        if (!this.data.DpId) {
          this.$message.error("请选择所属组织");
          return false;
        }
        if (this.opCoopDtsDtos.length == 0) {
          this.$message.error("需要【基础数据】设置培训车型");
          return false;
        } else {
          var checkNum = this.opCoopDtsDtos.every(x => {
            return x.Price > 0;
          })
          if(!checkNum) {
            this.$message.error("出库单价须大于0");
            return false;
          }
          if(this.data.CoopMode != '学员名额出库一次性收费') {
            var checkNum2 = this.opCoopDtsDtos.every(x => {
              return x.PracticePrice > 0 && x.SimulatePrice > 0;
            })
            if(!checkNum2) {
              this.$message.error("计时单价须大于0");
              return false;
            }
          }
        }
        if (this.data.Status == 0 && this.data.SignDate > this.data.StopDate) {
          this.$message.error("签约时间不能大于终止时间");
          return false;
        }
        this.data.opCoopDtsDtos = [];
        this.opCoopDtsDtos.forEach(e => {
          if (e.T === 0 || e.T === 1) {
            this.data.opCoopDtsDtos.push(e);
          }
        });
      },
      toSave(type) {
        //提交
        this.isSubmit = type==1;
        this.save();
      },
      onClosed() {
        this.TreeData = [];
        this.opCoopDtsDtos = [];
        this.isSubmit = false;
        this.$refs.treeSelect.clearHandle();
      }
    }
  };
</script>
<style lang="scss" scoped>
  /deep/ .el-tree .el-tree-node .el-tree-node__content {
    height: 35px;
  }

  /deep/ .form-border {
    .el-form-item__content {
      border: 1px solid #ddd;
      border-radius: 3px;
    }
  }
  /deep/ .append .el-input-group__append {
    padding:  0 6px;
  }
</style>